import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { editCaseInformationSummary } from "../../../../services/typedefine";
import "./case-information-summary.css";
import { Trans, useTranslation } from "react-i18next";
import { HelpModalPopup } from "@components/home-page/shared-components/modal-popup/help-modal-popup";
import { HpLogo } from "@components/home-page/shared-components/hp-logo/hp-logo";

const CaseInformationSummary: React.FC<editCaseInformationSummary> = ({
  attachedFilesData,
  caseInfoSummary,
}) => {
  const renderCell = (value: string | undefined) => (value ? value : "N/A");
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  function handleCallBack() {
    setOpen(true);
  }
  const validFileCount  = attachedFilesData?.Item3?.filter(
    (val: any) => !val?.Value?.includes("Federator")
  ) || []
  const popupHeader = () => {
    return (
      <p className="popup-header">
        <HpLogo></HpLogo>
        <span className="ml-2">
          {t("HPI.MainHomePage.SubmitnewCase.NewCase", {
            defaultValue: "Create a new case",
          })}
        </span>{" "}
      </p>
    );
  };
  return (
    <div className="case-information-summary">
      <h5 className="header-title">
        {t("HPI.EditCase.Case.Caseinformationsummary", {
          defaultValue: "Case Information Summary",
        })}
      </h5>
      <Container className="container-custom">
        <Row>
          <Col md={6} className="container-row">
            <Row>
              <Col md={4}>
                <label>{t("HPI.EditCase.Case.CaseID", { defaultValue: "Case ID" })}</label>
              </Col>
              <Col>{renderCell(caseInfoSummary.CaseId)}</Col>
            </Row>
            <Row>
              <Col md={4}>
                <label>
                  {t("HPI.EditCase.Case.Casetitle", {
                    defaultValue: "Case Title",
                  })}
                </label>
              </Col>
              <Col>{renderCell(caseInfoSummary.CaseTitle)}</Col>
            </Row>
            <Row>
              <Col md={4}>
                <label>{t("HPI.EditCase.Case.status", { defaultValue: "Case Status" })}</label>

                <HelpModalPopup
                  align={"start"}
                  id={"modal-popup"}
                  show={open}
                  onClose={() => setOpen(false)}
                  title={popupHeader()}
                  callback={handleCallBack}
                >
                  <p dangerouslySetInnerHTML={{__html:t("HPI.EditCase.CaseStatusTooltip.Content", {defaultValue:"The following is the guidance on case status:<br><br>New – The case has just been created<br>Elevated – The case is now being handled by a higher level agent<br>Active – The case is currently being worked upon<br>Pending call back – The customer is expecting a call back regarding this case<br>Request to close – You have requested to close this case<br>Closed – The case is currently closed<br>"})}}>
                    </p>
                </HelpModalPopup>
              </Col>
              <Col>{renderCell(caseInfoSummary.CaseStatus)}</Col>
            </Row>
            <Row>
              <Col md={4}>
                <label>
                  {t("HPI.EditCase.Case.Submittedby", {
                    defaultValue: "Submitted By",
                  })}
                </label>
              </Col>
              <Col>{renderCell(caseInfoSummary.SubmittedBy)}</Col>
            </Row>
            <Row>
              <Col md={4}>
                <label>
                  {t("HPI.CreateCase.CasePriority", {
                    defaultValue: "Case Priority",
                  })}
                </label>
              </Col>
              <Col>{renderCell(caseInfoSummary.Priority)}</Col>
            </Row>
          </Col>
          <Col md={6} className="container-row">
            <Row>
              <Col md={4}>
                <label>
                  {t("HPI.EditCase.Case.Datesubmitted", {
                    defaultValue: "Date Submitted",
                  })}
                </label>
              </Col>
              <Col>{renderCell(caseInfoSummary.SubmittedOn)}</Col>
            </Row>
            <Row>
              <Col md={4}>
                <label>
                  {t("HPI.EditCase.Case.Datelastupdated", {
                    defaultValue: "Date Last Updated",
                  })}
                </label>
              </Col>
              <Col>{renderCell(caseInfoSummary.ModifiedOn)}</Col>
            </Row>
            <Row>
              <Col md={4}>
                <label>
                  {t("HPI.EditCase.Case.Dateresolved", {
                    defaultValue: "Date Resolved",
                  })}
                </label>
              </Col>
              <Col>{renderCell(caseInfoSummary.SpnResolvedDate)}</Col>
            </Row>
            <Row>
              <Col md={4}>
                <label>
                  {t("HPI.EditCase.Case.Attachmentsinfo", {
                    defaultValue: "Attachments",
                  })}
                </label>
              </Col>
              <Col>{renderCell(validFileCount?.length +" "+ t('HPI.EditCase.Cs.TotalFiles',{defaultValue:'total files'}))}</Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CaseInformationSummary;
